import React from "react";
import * as Comp from "../../../../components";

interface OwnProps {
    formComponent: Comp.Validation.IComponentWithValidatedForm;
    label?: string;
    namePrefix: string;
}

interface OwnState {
}

export class ContentTextEditor extends React.Component<OwnProps, OwnState> {
    public render() {
        const label = this.props.label
            ? <Comp.Editors.FormField name=""><hr /><h2>{this.props.label}</h2></Comp.Editors.FormField>
            : null;

        return <div className="content-block-editor">
            {label}
            <Comp.Editors.RichTextField formComponent={this.props.formComponent} isAdmin label="" name={this.props.namePrefix + "body"} />
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminPage/edit/editors/ContentTextEditor.tsx